import React from "react";

export default function CaptureIcon({
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  onClick,
  className,
  style = {},
  ...rest
}) {
  const mergedStyle = Object.assign(
    { width: size, height: size, cursor: onClick ? "pointer" : undefined },
    style
  );
  const svgProps = {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    fill: "none",
    stroke: color,
    strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    onClick,
    className,
    style: mergedStyle,
    ...rest
  };
  return React.createElement(
    "svg",
    svgProps,
    React.createElement("circle", { cx: 12, cy: 12, r: 10 }),
    React.createElement("path", { d: "m14.31 8 5.74 9.94" }),
    React.createElement("path", { d: "M9.69 8h11.48" }),
    React.createElement("path", { d: "m7.38 12 5.74-9.94" }),
    React.createElement("path", { d: "M9.69 16 3.95 6.06" }),
    React.createElement("path", { d: "M14.31 16H2.83" }),
    React.createElement("path", { d: "m16.62 12-5.74 9.94" })
  );
}